import { all, fork } from 'redux-saga/effects'

import getStatesForRegionSaga from './sagas/getStatesForRegion'

function* StatesSaga() {
  yield all([fork(getStatesForRegionSaga)])
}

export default StatesSaga
